import React, { useEffect, useState } from 'react';

import VisualizationContainerSwitch, {
  VisualizationContainer,
} from 'redhotmagma-visualization/VisualizationContainer';
import FullScreenViewContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/FullScreenView';
import NoVisualization from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Components/NoVisualization/NoVisualization';

import Magnifier from '../Magnifier/Magnifier';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import useGroundPlanUrl from '../../Hooks/useGroundPlanUrl';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  splitVisualizationContainer: {
    display: 'flex',
    maxHeight: 'calc(100% - 140px)',
    flex: 1,
    width: '100%',
    maxWidth: 1600,
    margin: '0 auto',
  },
  visualizationContainer: {
    position: 'relative',
    width: '66%',
    '& canvas': {
      marginLeft: 'auto',
    },
  },
  floorPlanContainer: {
    flex: 1,
    display: 'flex',
    width: '34%',
  },
  image: {
    pointerEvents: 'none',
    '-webkit-touch-callout': 'none',
  },
  noteFloorPlan: {
    padding: 20,
    alignSelf: 'center',
    textAlign: 'center',
    [theme.breakpoints.up(theme.creator.viewSelectBreakpoint)]: {
      marginLeft: -200,
    },
  },
  floorPlanErrorMessage: {
    margin: 'auto',
  },
}));

const SplitVisualizationContainer = (props) => {
  const classes = useStyles();
  const groundPlanUrl = useGroundPlanUrl();
  const [groundPlanError, setGroundPlanError] = useState(false);
  const [hasMagnifier, setHasMagnifier] = useState(false);
  useEffect(() => {
    setGroundPlanError(false);
  }, [groundPlanUrl]);
  return (
    <div className={classes.root}>
      <div className={classes.splitVisualizationContainer}>
        <div className={classes.visualizationContainer}>
          <VisualizationContainer {...props} />
        </div>
        <div className={classes.floorPlanContainer}>
          {groundPlanUrl && !groundPlanError && hasMagnifier ? (
            <Magnifier
              minifiedChildren={
                <img
                  src={groundPlanUrl}
                  alt=""
                  className={classes.image}
                  onError={() => setGroundPlanError(true)}
                />
              }
              magnifiedChildren={
                <img
                  src={groundPlanUrl}
                  alt=""
                  className={classes.image}
                  onError={() => setGroundPlanError(true)}
                  height="2048px"
                />
              }
            />
          ) : (
            <img
              src={groundPlanUrl}
              alt=""
              className={classes.image}
              onError={() => setGroundPlanError(true)}
            />
          )}
          {groundPlanError && (
            <div className={classes.floorPlanErrorMessage}>
              <Typography variant="body2">{t('floorPlanIsNotAvailable')}</Typography>
            </div>
          )}
        </div>
      </div>
      <div className={classes.noteFloorPlan}>
        <Typography variant="body2" dangerouslySetInnerHTML={{ __html: t('noteFloorPlan') }} />
      </div>
    </div>
  );
};

export const renderVisualization = ({ fullScreenViewProps }) => (
  <FullScreenViewContainer {...fullScreenViewProps}>
    <React.Suspense fallback={<div>Loading Visualization Component...</div>}>
      <VisualizationContainerSwitch
        BrokenComponent={NoVisualization}
        VisualizationContainerComponent={SplitVisualizationContainer}
      />
    </React.Suspense>
  </FullScreenViewContainer>
);
